import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import Layout from "@/layout";
import store from "@/store";
import Login from "../views/login/";
/**
 *  同步路由
 * */

//  测试
export const demomap = [
  {
    path: "/login",
    hidden: true,
    children: []
  },
  {
    path: "/404",
    hidden: true,
    children: []
  },
  {
    path: "/",
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: {
          title: "首页",
          role: ["admin", "vendor"],
          // icon: "dashboard",
          affix: true
        }
      }
    ]
  },

  // {
  //   path: 'campaign',
  //   component: Layout,
  //   redirect: 'campaign',
  //   name: 'Campaign',
  //   meta: { title: '营销活动2', role: ['admin', 'vendor'], icon: '' , affix: true},
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Campaign',
  //       component: () => import('@/views/campaign/index'),
  //       meta: { title: '营销活动页面', role: ['admin', 'vendor'], icon: 'tree' }
  //     },
  //     {
  //       path: '/campaignTemplate',
  //       name: 'CampaignTemplate',
  //       component: () => import('@/views/campaign/campaignTemplate'),
  //       redirect:'campaignTemplate/selectmodules',
  //       meta: { title: '营销活动模版库', role: ['admin', 'vendor'], icon: 'table' },
  //       children: [{
  //         path: '/selectmodules',
  //         name: 'selectmodules',
  //         component: () => import('@/views/campaign/selectmodules'),
  //         meta: { title: '新建活动', role: ['admin', 'vendor'], icon: 'tree' },
  //       }]
  //     },
  //     {
  //       path: 'appPorcelain',
  //       name: 'AppPorcelain',
  //       component: () => import('@/views/campaign/appPorcelain'),
  //       meta: { title: 'App瓷片区管理', role: ['admin', 'vendor'], icon: 'table' }
  //     },

  //   ]
  // },

  { path: "*", children: [], redirect: "/404", hidden: true }
];

export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    children: []
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
    children: []
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: {
          title: "首页",
          role: ["admin", "vendor"],
          icon: "dashboard",
          affix: true
        }
      }
    ]
  },
  {
    path: "/providerManage",
    component: Layout,
    redirect: "/providerManage/provider",
    name: "ProviderManage",
    meta: { title: "供应商管理", role: ["admin", "vendor"], icon: "example" },
    children: [
      {
        path: "provider",
        name: "Provider",
        component: () => import("@/views/provider/index"),
        meta: { title: "供应商", role: ["admin", "vendor"], icon: "table" }
      },

      {
        path: "account",
        name: "Account",
        component: () => import("@/views/account/index"),
        meta: { title: "账号管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "information",
        component: () => import("@/views/information/index"),
        name: "information",
        meta: { title: "供应商基本信息维护", icon: "tree" }
      }
    ]
  },
  {
    path: "/caseManagement",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/caseManagement/index"),
        name: "CaseManagement",
        meta: { title: "案例管理", role: ["admin", "vendor"], icon: "table" }
      }
    ]
  },
  {
    path: "/leaveMessage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/leaveMessage/index"),
        name: "LeaveMessage",
        meta: { title: "留言管理", role: ["admin", "vendor"], icon: "tree" }
      }
    ]
  },

  /////lxs
  {
    path: "/hotelLogo",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/hotelLogo/index"),
        name: "hotelLogo",
        meta: { title: "酒店品牌管理", icon: "tree" }
      }
    ]
  },
  {
    path: "/companyBrand",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/companyBrand/index"),
        name: "companyBrand",
        meta: { title: "公司品牌管理", icon: "tree" }
      }
    ]
  },
  {
    path: "/hotelBanner",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/hotelBanner/index"),
        name: "hotelBanner",
        meta: { title: "酒店首图管理", icon: "tree" }
      }
    ]
  },
  {
    path: "/supplierServiceManagement",
    component: Layout,
    redirect: "/selfHelp",
    name: "ServiceManagement",
    meta: { title: "供应商帮助中心", role: ["admin", "vendor"] },
    children: [
      {
        path: "selfHelp",
        name: "selfHelp",
        component: () =>
          import("@/views/supplierServiceManagement/selfHelp.vue"),
        meta: { title: "首页展示管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "faq",
        name: "faq",
        component: () => import("@/views/supplierServiceManagement/faq.vue"),
        meta: { title: "问题管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "ProblemClassification",
        name: "ProblemClassification",
        component: () =>
          import("@/views/supplierServiceManagement/ProblemClassification.vue"),
        meta: { title: "目录管理", role: ["admin", "vendor"], icon: "tree" }
      }
    ]
  },
  {
    path: "/RuleManagement",
    component: Layout,
    redirect: "/selfHelp",
    name: "RuleManagement",
    meta: { title: "规则中心", role: ["admin", "vendor"] },
    children: [
      {
        path: "selfHelp",
        name: "selfHelp",
        component: () =>
          import("@/views/RuleManagement/selfHelp.vue"),
        meta: { title: "首页展示管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "faq",
        name: "faq",
        component: () => import("@/views/RuleManagement/faq.vue"),
        meta: { title: "问题管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "ProblemClassification",
        name: "ProblemClassification",
        component: () =>
          import("@/views/RuleManagement/ProblemClassification.vue"),
        meta: { title: "目录管理", role: ["admin", "vendor"], icon: "tree" }
      }
    ]
  },
  {
    path: "/ServiceManagement",
    component: Layout,
    redirect: "/selfHelp",
    name: "ServiceManagement",
    meta: { title: "帮助中心", role: ["admin", "vendor"] },
    children: [
      {
        path: "selfHelp",
        name: "selfHelp",
        component: () => import("@/views//ServiceManagement/selfHelp.vue"),
        meta: { title: "首页展示管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "faq",
        name: "faq",
        component: () => import("@/views//ServiceManagement/faq.vue"),
        meta: { title: "问题管理", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "ProblemClassification",
        name: "ProblemClassification",
        component: () =>
          import("@/views//ServiceManagement/ProblemClassification.vue"),
        meta: { title: "栏目管理", role: ["admin", "vendor"], icon: "tree" }
      }
    ]
  },
  {
    path: "/campaign",
    component: Layout,
    redirect: "/campaign",
    name: "Campaign",
    meta: {
      title: "营销活动1",
      role: ["admin", "vendor"],
      icon: "",
      affix: true
    },
    children: [
      {
        path: "index",
        name: "Campaign",
        component: () => import("@/views/campaign/index"),
        meta: {
          title: "营销活动页面",
          role: ["admin", "vendor"],
          icon: "tree",
          hidden: true
        }
        // children: []
      },
      // {
      //   path: 'selectTemplate',
      //   name: 'selectTemplate',
      //   component: () => import('@/views/campaign/selectTemplate'),
      //   meta: { title: '新建活动1', role: ['admin', 'vendor'], icon: 'tree' },
      // }, {
      //   path: 'newActive',
      //   name: 'newActive',
      //   component: () => import('@/views/campaign/newActive'),
      //   meta: { title: '新建活动2', role: ['admin', 'vendor'], icon: 'tree' },
      // },
      {
        path: "campaignTemplate",
        name: "CampaignTemplate",
        component: () => import("@/views/campaign/campaignTemplate"),
        meta: {
          title: "营销活动模版库",
          role: ["admin", "vendor"],
          icon: "table"
        },
        children: [
          {
            path: "selectmodules",
            name: "Campaign",
            component: () => import("@/views/campaign/selectmodules"),
            meta: {
              title: "营销活动页面",
              role: ["admin", "vendor"],
              icon: "tree"
            }
          }
        ]
      },

      {
        path: "ImageManagement",
        name: "ImageManagement",
        component: () => import("@/views/campaign/ImageManagement"),
        meta: { title: "图片管理", role: ["admin", "vendor"], icon: "table" }
      },
      {
        path: "helpCenterImg",
        name: "helpCenterImg",
        component: () => import("@/views/campaign/helpCenteImg"),
        meta: {
          title: "帮助中心入口配置",
          role: ["admin", "vendor"],
          icon: "table"
        }
      },
      {
        path: "appPorcelain",
        name: "AppPorcelain",
        component: () => import("@/views/campaign/appPorcelain"),
        meta: {
          title: "App瓷片区管理",
          role: ["admin", "vendor"],
          icon: "table"
        }
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];
/**
 * 异步路由表
 */

export const asyncRouterMap = [
  {
    path: "/providerManage",
    component: Layout,
    redirect: "/providerManage/provider",
    name: "ProviderManage",
    meta: { title: "供应商管理", role: ["admin", "vendor"], icon: "example" },
    children: [
      {
        path: "provider",
        name: "Provider",
        component: () => import("@/views/provider/index"),
        meta: { title: "供应商", role: ["admin", "vendor"], icon: "table" }
      },
      {
        path: "account",
        name: "Account",
        component: () => import("@/views/account/index"),
        meta: { title: "账号管理", role: ["admin", "vendor"], icon: "tree" }
      }
    ]
  },
  {
    path: "/caseManagement",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/caseManagement/index"),
        name: "CaseManagement",
        meta: { title: "案例管理", role: ["admin", "vendor"], icon: "table" }
      }
    ]
  },
  {
    path: "/leaveMessage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/leaveMessage/index"),
        name: "LeaveMessage",
        meta: { title: "留言管理", role: ["admin", "vendor"], icon: "tree" }
      }
    ]
  },

  {
    path: "/campaign",
    component: Layout,
    redirect: "/campaign",
    name: "Campaign",
    meta: {
      title: "营销活动2",
      role: ["admin", "vendor"],
      icon: "",
      affix: true
    },
    children: [
      {
        path: "index",
        name: "Campaign",
        component: () => import("@/views/campaign/index"),
        meta: { title: "营销活动页面", role: ["admin", "vendor"], icon: "tree" }
      },
      {
        path: "campaignTemplate",
        name: "CampaignTemplate",
        component: () => import("@/views/campaign/campaignTemplate"),
        meta: {
          title: "营销活动模版库",
          role: ["admin", "vendor"],
          icon: "table"
        },
        children: [
          {
            path: "selectmodules",
            name: "Campaign",
            component: () => import("@/views/campaign/selectmodules"),
            meta: {
              title: "营销活动页面",
              role: ["admin", "vendor"],
              icon: "tree"
            }
          }
        ]
      },
      {
        path: "appPorcelain",
        name: "AppPorcelain",
        component: () => import("@/views/campaign/appPorcelain"),
        meta: {
          title: "App瓷片区管理",
          role: ["admin", "vendor"],
          icon: "table"
        }
      }
    ]
  }
];

const createRouter = () =>
  new Router({
    mode: "hash", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  });
const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
